import React from 'react'

function Spinner() {
    return (
        <button type='button' className='mc-auth-btn py-2 cursor-notallow' disabled>
            <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </button>
    )
}

export default Spinner
